var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/tooltip/tooltip.tsx";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "core-js/modules/web.dom-collections.iterator.js";
import { Portal } from '@reach/portal';
import { TooltipPopup, useTooltip } from '@reach/tooltip';
import React from 'react';
import './tooltip.css';

const centered = (triggerRect, tooltipRect) => {
  const triggerCenter = triggerRect.left + triggerRect.width / 2;
  const left = triggerCenter - tooltipRect.width / 2;
  const maxLeft = window.innerWidth - tooltipRect.width - 2;
  return {
    left: Math.min(Math.max(2, left), maxLeft) + window.scrollX,
    top: triggerRect.bottom + 8 + window.scrollY
  };
};
/** Hoverable tooltip element. */


const Tooltip = _ref => {
  let {
    children,
    text
  } = _ref;
  // get the props from useTooltip
  const [trigger, tooltip] = useTooltip(); // destructure off what we need to position the triangle

  const {
    isVisible,
    triggerRect
  } = tooltip;
  return /*#__PURE__*/React.createElement(React.Fragment, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.cloneElement(children, trigger), isVisible &&
  /*#__PURE__*/
  // The Triangle. We position it relative to the trigger, not the popup
  // so that collisions don't have a triangle pointing off to nowhere.
  // Using a Portal may seem a little extreme, but we can keep the
  // positioning logic simpler here instead of needing to consider
  // the popup's position relative to the trigger and collisions
  React.createElement(Portal, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-reach-tooltip-arrow": "true",
    style: {
      left: triggerRect && triggerRect.left - 10 + triggerRect.width / 2,
      top: triggerRect && triggerRect.bottom + window.scrollY
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(TooltipPopup, _extends({}, tooltip, {
    label: text,
    "aria-label": text,
    position: centered,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 7
    }
  })));
};

export default Tooltip;